(function () {
  const videos = document.querySelectorAll(".video-js");

  Array.prototype.forEach.call(videos, function (el) {
    const videoPlayer = el.querySelector("video");
    const videoPlayBtn = el.querySelector("button");
    const container = el.querySelector(".reveal__container"); // Add this line


    // play the video when play button is clicked
    videoPlayBtn.addEventListener("click", function (event) {
      videoPlayer.play();
      toggleControls();
      event.preventDefault();
    });

    // return to beginning at ended
    videoPlayer.addEventListener("ended", function (event) {
      videoPlayer.autoplay = false;
      videoPlayer.load();
      toggleControls();
    });

    function toggleControls() {
      if (videoPlayer.paused) {
        videoPlayBtn.classList.remove("hide");
        videoPlayer.removeAttribute("controls");
      } else {
        videoPlayBtn.classList.add("hide");
        videoPlayer.setAttribute("controls", "controls");
      }
    }
  });
})();
